import { Chip, styled } from '@mui/material';

export const TrlPillPendingStyled = styled(Chip)(({ theme }) => ({
  border: `solid 1px ${theme.palette.colors.pillBorder}`,
  lineHeight: 'normal',
  borderRadius: '8px',
  width: '40px',
  minWidth: '40px',
  height: '14px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: theme.palette.colors.secondaryBackground,
  justifyContent: 'center',
  '& span': {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'unset',
    textOverflow: 'unset',
  },
  [theme.breakpoints.down('lg')]: {
    width: '56px',
    height: '12px',
  },
}));

export const TrlPillDotStyled = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  height: '4px',
  width: '4px',
  background: theme.palette.colors.mainFocused,
  margin: '0px 1px',
}));
